module.exports = __webpack_public_path__ + "img/content-banner.b4047e07.svg";